import { lazy } from "react";

const Kei = lazy(() => import("../pages/Kei"));
const Simple = lazy(() => import("../pages/Simple"));
const Shiboriyu = lazy(() => import("../pages/shiboriyu"));
const Resume = lazy(() => import("../pages/Resume"));
const Company = lazy(() => import("../pages/Company"));
const Self = lazy(() => import("../pages/Self"));
const Automail = lazy(() => import("../pages/Automail1"));
const Translate = lazy(() => import("../pages/Translate"));
const More = lazy(() => import("../pages/More"));
const Coffee = lazy(() => import("../pages/coffee"));
const Decision = lazy(() => import("../pages/Decision"));
const LearningPlan = lazy(() => import("../pages/LearningPlan"));
const FastLearning = lazy(() => import("../pages/FastLearning"));
const Best = lazy(() => import("../pages/Best"));
const Tutor = lazy(() => import("../pages/Tutor"));
const Involve = lazy(() => import("../pages/Involve"));
const Intro = lazy(() => import("../pages/intro"));
const Interview = lazy(() => import("../pages/Interview"));

export const appRoutes = [
  { path: "/", Page: Kei },
  { path: "/Simple", Page: Simple },
  { path: "/Gptshiboriyu", Page: Shiboriyu, menu: "jobHunt", label: "Gpt-shiboriyu" },
  { path: "/GptResume", Page: Resume, menu: "jobHunt", label: "Gpt-Resume" },
  { path: "/GptCompany", Page: Company, menu: "jobHunt", label: "Gpt-Company" },
  { path: "/Gptselfcheck", Page: Self, menu: "jobHunt", label: "Gpt-Selfcheck" },
  { path: "/Keigo", Page: Kei },
  { path: "/Mail", Page: Automail, menu: "tool", label: "Gpt-Mail" },
  { path: "/Translate", Page: Translate, menu: "tool", label: "Gpt-Translate" },
  { path: "/advise", Page: More },
  { path: "/coffee", Page: Coffee },
  { path: "/Decision", Page: Decision, menu: "tool", label: "Gpt-Decision" },
  { path: "/LP", Page: LearningPlan, menu: "tool", label: "Gpt-LearnNewSkill" },
  { path: "/FastLearning", Page: FastLearning, menu: "tool", label: "Gpt-FastLearning" },
  { path: "/LearnFromBest", Page: Best, menu: "tool", label: "Gpt-LearnFromBest" },
  { path: "/LearnTutor", Page: Tutor, menu: "tool", label: "Gpt-LearningTutor" },
  { path: "/Involve", Page: Involve, menu: "tool", label: "Gpt-Involve" },
  { path: "/introduction", Page: Intro, menu: "jobHunt", label: "Howtouse" },
  { path: "/GptInterview", Page: Interview, menu: "jobHunt", label: "Gpt-Interview" },
];

export const navMenus = {
  tool: appRoutes.filter((route) => route.menu === "tool"),
  jobHunt: appRoutes.filter((route) => route.menu === "jobHunt"),
  contact: [
    { path: "https://discord.gg/ud6RpY39nG", label: "Discord", external: true },
    { path: "/advise", label: "More" },
    { path: "/coffee", label: "Coffee" },
  ],
};
